import { push } from 'connected-react-router';

export default (creditId) => (dispatch) =>
    dispatch(push(`/credits/file/${creditId || ''}`));
